export const randomDate = (start, end) => new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/randomDate.ts